var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menus-div"},[(_vm.label)?_c('p',{staticClass:"menu-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"menu-list list-unstyled",class:_vm.type,style:(_vm.type == 'float' ? 'max-height: calc(70vh); top: 0;' : '')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }